import styled from "styled-components"
import styleConstants from "../../../../constants/styleConstants"

export const CompanySectionsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0.8rem;

  @media (min-width: ${styleConstants.desktopMinWidth}) {
    padding: 0;
    flex-direction: row;
    justify-content: space-between;
  }
`

// eslint-disable-next-line no-unexpected-multiline
export const CompanySectionsListItemWrapper = styled.div<{
  hideOnMobile?: boolean
}>`
  display: ${({hideOnMobile}) => (hideOnMobile ? "none" : "block")};

  @media (min-width: ${styleConstants.desktopMinWidth}) {
    display: block;
    width: calc(33.3% - 0.66rem);
  }
`
